import React, { useMemo } from "react";
import styles from "../../assets/styles/Support/Support.module.scss";
import {
  AppPage,
  MimaNewFilter,
  PageLoader,
  MimaButton,
  MimaTable,
} from "../../components";
import { useState } from "react";
import moment from "moment";
import {
  CreateSupportContainer,
  ViewMoreSupportContainer,
} from "../../containers";
import { AnimatePresence } from "framer-motion";
import constant from "../../utils/constant";

const Support = ({
  loading,
  goToViewMoreModal,
  ViewMoreModal,
  closeModal,
  filterHandler,
  goToCreateSupport,
  createSupportModal,
  isLoading,
  supportData,
  isFetching,
  limit,
  onLimitChange,
  setSearchQuery,
  currentPage,
  setCurrentPage,
}) => {
  const [showFilter, setShowFilter] = useState(false);
  const [data, setData] = useState({});

  const filterByData = [{ value: "Status", key: "status" }];

  const statusParams = [
    { value: "Open", key: "OPEN" },
    { value: "Closed", key: "CLOSED" },
    { value: "Processing", key: "PROCESSING" },
  ];

  const tableData = useMemo(() => {
    if (supportData?.status === constant.Success) {
      return supportData?.data?.faqs || [];
    }
    return [];
  }, [supportData]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const createdDate = cell.row.original?.createdAt;
        return <span>{moment(createdDate).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Business Name",
      accessor: "tradingName",
      Cell: ({ cell }) => {
        const businessName = cell.row.original.business?.tradingName;
        return <span>{businessName}</span>;
      },
    },

    {
      Header: "Title",
      accessor: "title",
    },
    {
      Header: "Description",
      accessor: "message",
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: ({ cell }) => {
        const status = cell.value;
        const statusClass = `status ${status === "CLOSED" ? "status__green" : status === "PROCESSING" ? "status__dark__yellow" : "status__red"}`;
        return <span className={statusClass}>{status}</span>;
      },
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        const item = cell.row.original;
        return (
          <span
            className="tableAction__text"
            onClick={() => {
              setData(item);
              goToViewMoreModal();
            }}
          >
            View More
          </span>
        );
      },
    },
  ];

  return (
    <AppPage pageTitle="Support">
      {loading ? (
        <PageLoader title="while we load your information" />
      ) : (
        <>
          <div className={styles.filterClass}>
            <MimaButton
              title={showFilter ? "Close Filter" : "Filter"}
              onClick={() => setShowFilter(!showFilter)}
            />
            <MimaButton
              title="Create Ticket"
              width={30}
              onClick={goToCreateSupport}
            />
          </div>

          <MimaNewFilter
            showFilter={showFilter}
            setShowFilter={setShowFilter}
            filterByData={filterByData}
            filterHandler={filterHandler}
            statusParams={statusParams}
          />
          <MimaTable
            tableData={tableData}
            tableColumns={tableColumns}
            searchPlaceholder="Search Subscription"
            searchVariant="wide"
            totalItems={data?.data?.totalCounts}
            onLimitChange={onLimitChange}
            isLoading={isLoading}
            isFetching={isFetching}
            limit={limit}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            setSearchQuery={setSearchQuery}
          />

          {(ViewMoreModal || createSupportModal) && (
            <div className="modal">
              <AnimatePresence>
                {ViewMoreModal && (
                  <ViewMoreSupportContainer
                    data={data}
                    closeModal={closeModal}
                  />
                )}
                {createSupportModal && (
                  <CreateSupportContainer closeModal={closeModal} />
                )}
              </AnimatePresence>
            </div>
          )}
        </>
      )}
    </AppPage>
  );
};
export default Support;
